// extracted by mini-css-extract-plugin
module.exports = {"countdown":"CountDownTimer_countdown__3D8NQ","cdt":"CountDownTimer_cdt__10Cnj","countdownsizeMini":"CountDownTimer_countdownsizeMini__3NSf5","cdt1":"CountDownTimer_cdt1__2pZ6U"};